import { createContext, useContext, useState } from "react";

const S3context=createContext()

export const S3provider=({children})=>{
      const [s3loading, setS3Loading] = useState(false)
        const [progress, setProgress] = useState(0)
        const [timeRemaining, setTimeRemaining] = useState(null);
        const [uploadSpeed, setUploadSpeed] = useState(null);
        const [uploadedFiles, setUploadedFiles] = useState(0);
        const [totalSize, setTotalSize] = useState(0);
        const [uploadedSize, setUploadedSize] = useState(0);
        return(
            <S3context.Provider value={{
                s3loading,
                setS3Loading,
                progress,
                setProgress,
                timeRemaining,
                setTimeRemaining,
                uploadSpeed,
                setUploadSpeed,
                uploadedFiles,
                setUploadedFiles,
                totalSize,
                setTotalSize,
                uploadedSize,setUploadedSize
            }}>
                {children}
            </S3context.Provider>
        )
}

export const useS3context=()=>useContext(S3context)